// 获取cookie
export function getCookie (name) {
    var arr = null
    var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    if (document.cookie.match(reg)) {
        arr = document.cookie.match(reg)
        try {
          return (decodeURIComponent(arr[2]))
        } catch (e) {
          let str = arr[2].replace(/%/g, '%25')
          return (decodeURIComponent(str));
        }
    } else {
      return null
    }
}
// 设置cookie,增加到vue实例方便全局调用
export function setCookie (name, value, domain, expire) {
    var second = expire
    var exp = new Date()
    exp.setTime(exp.getTime() + second * 1000)
    document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + exp.toGMTString() + ';path=/;domain=' + domain
}
// 删除cookie
export function delCookie (name, domain) {
    var exp = new Date()
    exp.setTime(exp.getTime() - 1)
    var cval = getCookie(name)
    if (cval != null) {
        document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString() + ';path=/;domain=' + domain
    }
}